import { render, staticRenderFns } from "./UpdateCard.vue?vue&type=template&id=4c4b233e&scoped=true"
import script from "./UpdateCard.vue?vue&type=script&lang=js"
export * from "./UpdateCard.vue?vue&type=script&lang=js"
import style0 from "./UpdateCard.vue?vue&type=style&index=0&id=4c4b233e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4b233e",
  null
  
)

export default component.exports